import { updateAdditionalUserInfo } from 'app/utils/users';
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

type Props = {}

const initialValues = {
  formValue: {
    name: '',
    school: '',
    grade: '',
    customGrade: '',
    phone: '',
  }
}


const useOnBoardingForm = (props: Props) => {

  const navigate = useNavigate()
  const [isLoading, setIsLoading] = React.useState(false)
  const [formValue, setFormValue] = React.useState(initialValues?.formValue)

  const updateFormValue = (key: string, value: any) => {

    try {

      const newFormValue = {...formValue, [key]: value}
      setFormValue(newFormValue)


    }
    catch (err) {

    }

  }

  const onSubmit  = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    updateAdditionalUserInfo(formValue)
    navigate('/dashboard')
  }

  return {
    formValue,
    updateFormValue,
    isLoading,
    setIsLoading,
    onSubmit,
  }
}

export default useOnBoardingForm